/**
 * User: Rob Richard
 * Date: 5/11/15
 * Time: 4:41 PM
 */

'use strict';

var PaymentMethod = require('bunsen/models/ecomm/PaymentMethodModel');
var PayPalAccount = module.exports = PaymentMethod.extend();

var _ = require('underscore');
var Backbone = require('dibs-backbone');
var WalletPaymentMethod = require('bunsen/models/identity/WalletPaymentMethod');
var Address = require('bunsen/models/Address');
var paypal = require('bunsen/helpers/paypal');
var ends = require('dibs-endpoints');

_.extend(PayPalAccount.prototype, {
    defaults: {
        apiType : 'payPalAccount',
        paymentMethodType : 'PAYPAL_ACCOUNT',
        billingAddress: {}
    },
    relations: [
        {
            type: Backbone.One,
            key: 'billingAddress',
            relatedModel: Address
        }
    ],
    getDisplayVal: function () {
        return 'PayPal';
    },
    setFromBraintree: function (paypalData) {
        this.set(paypal.getPayPalModelData(paypalData));
    },
    saveToVault: function (userId, options) {
        var vaultRequest;
        options = _.extend({
            url: ends.vault(userId)
        }, options);

        options.queries = _.extend({
            paymentMethodNonce: this.get('nonce')
        }, options.queries);

        vaultRequest = new WalletPaymentMethod();
        return vaultRequest.save({}, options)
            .then(function () {
                var paymentMethod = vaultRequest.get('paymentMethod');
                this.clear();
                if (paymentMethod) {
                    this.set(paymentMethod.toJSON());
                }
            }.bind(this));
    }
});

_.extend(PayPalAccount, {
    createFromBraintree: function (paypalData) {
        return new PayPalAccount(paypal.getPayPalModelData(paypalData));
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/payment-methods/PayPalAccount.js
// module id = 191
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55